export const addNewNoteHandler = (state, payload) => {
  const _notes = [...state.notes];

  _notes.push(payload);
  return { ...state, notes: [..._notes] };
};
